<template>
  <main id="contents">
    <div v-if="hasTitle" class="page-top">
      <div class="page-top-inner-wrap">
        <h1 class="page-title" tabindex="0">고객센터</h1>
      </div>
    </div>

    <CustomerSupportContainer v-if="isNoticeView" />
    <EventListContainer v-if="isEventView" />
  </main>
</template>

<script>
  import _ from 'lodash'
  import EventListContainer from '@/components/customer/EventListContainer'
  import CustomerSupportContainer from '@/components/customer/CustomerSupportContainer'

  export default {
    name: 'CustomerSupport',
    components: {
      EventListContainer,
      CustomerSupportContainer,
    },
    computed: {
      type() {
        return this.$route?.meta?.type ?? ''
      },
      hasTitle() {
        const routeName = _.get(this.$route, 'name', '')
        return (
          routeName !== 'event_list' &&
          routeName !== 'event_board_list' &&
          routeName !== 'event_board_view' &&
          routeName !== 'event_view'
        )
      },
      isEventView() {
        return this.type === 'event'
      },
      isNoticeView() {
        return this.type === 'notice'
      },
    },
  }
</script>
<style lang="scss" src="@/assets/scss/category/member.scss" />
<style lang="scss" src="@/assets/scss/category/customer.scss" />
